import axios from 'axios'
import SvgCantos from '.././Cantostodos'
import Actualizar from '.././Actualizarregistro'
export default {
  name: 'listador',
  components: {
    SvgCantos, Actualizar
  },
  data () {
    return {
      cantidad: '', largo: '', ancho: '', detalle: '', giro: 1, alerta: 0
    }
  },
  props:['msg'],
  created () {
    if (this.msg > 0){
      this.buscarmensaje()
    }
  },
  methods: {
    buscarmensaje () {
      this.alerta = this.msg
    },
    respuestaalerta: function (response) {
      if(response.data.estado === 1) {
        alerta.push({'tipo': response.data.alerta.tipo, 'mensaje': response.data.alerta.mensaje })  
      } else {
        erroralertaapi(response)
      }
    },
    erroralertaapi: function (response) {

    },
  	procesarpieza: function (event) {
  		if(this.$store.getters.piezavalida == 1){
            this.$store.dispatch('PROCESAR_PIEZA')
            this.vaciarpieza()
  		}else{
  			console.log('no valida')
  		}
  	},
  	vaciarpieza: function (event) {
  		this.cantidad = '' 
  		this.largo = ''
  		this.ancho = ''
  		this.detalle = ''
  		this.$store.dispatch('VACIAR_PIEZA')
      document.getElementById("cantidad").focus();
  	},
    vaciarpedido: function (event) {
      this.vaciarpieza()
      this.$store.dispatch('VACIAR_PEDIDO')
    },
  	eliminarpieza: function (id) {
  		this.$store.dispatch('ELIMINAR_PIEZA', id)	
  	},
  	colorescanto1: function (canto) {
   	if (canto === 1) {
   		return 'canto1azul'
   	} else if (canto === 2){
   		return 'canto1rojo'
   	} else {
   		return 'canto1gris'
   	}
   },
   colorescanto2: function (canto) {
   	if (canto === 1) {
   		return 'canto2azul'
   	} else if (canto === 2){
   		return 'canto2rojo'
   	} else {
   		return 'canto2gris'
   	}
   },
   	colorescanto3: function (canto) {
   	if (canto === 1) {
   		return 'canto3azul'
   	} else if (canto === 2){
   		return 'canto3rojo'
   	} else {
   		return 'canto3gris'
   	}
   },
   colorescanto4: function (canto) {
   	if (canto === 1) {
   		return 'canto4azul'
   	} else if (canto === 2){
   		return 'canto4rojo'
   	} else {
   		return 'canto4gris'
   	}
   },
   enviarlista: function () {
   	this.$router.push('/procesarpedido')
   },
   listadepiezas (lista) {
   	return _.orderBy(lista, ['id'], ['desc'])
   },
   verificardetalle: function (input) {
     var re = /([\/\-\-\:\+\"\'\%\&\=\?\*\.\_])/g;
     return input.replace(re,"");
   }
  },
  computed: {
    alertaspendientes () {
      if (this.alerta > 0) {
        return this.alerta
      } else {
        return false
      }
    },
    totalmts2 () {
      return this.$store.getters.totalmt2
    },
    totalmts2usd () {
      return this.$store.getters.totalmt2usd
    },
    totalmtl045 () {
      return this.$store.getters.totalmtl045
    },
    totalmtl045usd () {
      return this.$store.getters.totalmtl045usd
    },
    totalmtl2 () {
      return this.$store.getters.totalmtl2
    },
    totalmtl2usd () {
      return this.$store.getters.totalmtl2usd
    },
    totalcorte () {
      return this.totalmts2usd + this.totalmtl045usd + this.totalmtl2usd
    },
    totalmtscorte () {
      return this.$store.getters.totalmtscorte
    },
   clasecantidad (){
   	if (this.cantidad > 0 && this.cantidad < 100) {
        return 'normal-input'
    } else {
        return 'error-input'
    }
   },
   claselargo (){
   	if (this.largo >= 50 && this.largo <= this.$store.getters.max_largo) {
        return 'normal-input'
    } else {
        return 'error-input'
    }
   },
   claseancho (){
   	if (this.ancho >= 50 && this.ancho <= this.$store.getters.max_ancho) {
        return 'normal-input'
    } else {
        return 'error-input'
    }
   },
   clasecolor_canto () {
    if (this.$store.getters.canto > 1 && this.$store.getters.color_canto !== '') {
      return 'normal-input'
    }
    return 'error-input'
   },
   clasecolor_placa () {
    if (this.$store.getters.placa !== 0 && this.$store.getters.color_placa !== '') {
      return 'normal-input'
    }
    return 'error-input'
   },
   piezavalida (){
   	return this.$store.getters.piezavalida
   },
   piezas (){
   	return this.$store.getters.piezas
   },
   piezascantidad () {
    return this.$store.getters.cantidadpiezas
   },
   clasedescripcion () {
    if (this.$store.getters.descripcionproyecto === '') {
      return 'error-input'
    } else {
      return 'normal-input'
    }
   },
   pedidovalido () {
    if (this.$store.getters.descripcionproyecto !== '' && this.$store.getters.cantidadpiezas > 0){
      if (this.$store.getters.placa !== '0' && this.$store.getters.color_placa !== '') {
        return true
      }
    }
    return false
   },
   descripcionproyecto: {
    get() {
      return this.$store.getters.descripcionproyecto
    },
    set (value) {
      this.$store.dispatch('CAMBIAR_DESCRIPCION', value)
    }
   },
    deshabilitarplaca () {
      if (this.$store.getters.placa > 0){
        return 1
      }
      return 0
    },
    deshabilitacanto () {
      if (this.$store.getters.canto > 1) {
        return 1
      } else {
        return 0
      }
    },
    placa: {
      get() {
        return this.$store.getters.placa
      },
      set (value) {
        this.$store.dispatch('CAMBIAR_PLACA', parseInt(value))
        if (value > 1) {
          this.giro = 0
        }
      }
    },
    canto: {
      get() {
        return this.$store.getters.canto
      },
      set (value) {
        this.$store.dispatch('CAMBIAR_CANTOT', value)
      }
    },
    color_placa: {
      get () {
        return this.$store.getters.color_placa
      },
      set (value) {
        this.$store.dispatch('CAMBIAR_COLOR', value)
      }
    },
    color_canto: {
      get () {
        return this.$store.getters.color_canto
      },
      set (value) {
        this.$store.dispatch('CAMBIAR_COLOR_CANTO', value)
      }
    }
  },
  watch: {
  	cantidad: function (nuevo) {
  		if(nuevo > 0 && nuevo < 100){
  		 this.$store.dispatch('CAMBIAR_CANTIDAD', nuevo)
  	    }else{
         this.$store.dispatch('CAMBIAR_CANTIDAD', 0)
  	    }
  	},
  	largo: function (nuevo) {
  		if(nuevo >= 50 && nuevo <= this.$store.getters.max_largo){
         this.$store.dispatch('CAMBIAR_LARGO', nuevo)
  		}else{
         this.$store.dispatch('CAMBIAR_LARGO', 0)
  		}
  	},
  	ancho: function (nuevo) {
		if(nuevo >= 50 && nuevo <= this.$store.getters.max_ancho){
         this.$store.dispatch('CAMBIAR_ANCHO', nuevo)
  		}else{
  	     this.$store.dispatch('CAMBIAR_ANCHO', 0)
  		}
  	},
  	detalle: function (nuevo) {
      var cambiado = this.verificardetalle(nuevo)
  		this.$store.dispatch('CAMBIAR_DETALLE', cambiado)
      this.detalle = cambiado
  	},
    giro: function (nuevo) {
      this.$store.dispatch('CAMBIAR_GIRO', nuevo)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/js/listador.js